// src/Map.js
// import React, { useEffect, useRef } from 'react';
// import maplibregl from 'maplibre-gl';
import {useState, useRef, useEffect} from 'react';
import 'maplibre-gl/dist/maplibre-gl.css';
import ReactMapGL from 'react-map-gl/maplibre';

export const Map = () => {
    const mapContainerRef = useRef(null);
    const [selectedLang, setLanguage] = useState('en');

    const changeLanguage = (ev) => {
        setLanguage(ev.target.value);
    };

    useEffect(() => {
        if (mapContainerRef.current) {
            const map = mapContainerRef.current.getMap();
            map.getStyle().layers.forEach((layer) => {
                if (layer.id.search(/label/) >= 0) {
                    const textField = map.getLayoutProperty(layer.id, 'text-field');
                    if (textField) {
                        map.setLayoutProperty(layer.id, 'text-field', [
                            'coalesce',
                            ['get', `name_${selectedLang}`],
                            ['get', 'name_en'],
                            ['get', 'name'],
                        ]);
                    }
                }
            });
        }
    }, [selectedLang]);

    return (
        <div>
            <select onChange={changeLanguage} value={selectedLang}>
              <option value="zh">Chinese</option>
              <option value="en">English</option>
              <option value="fr">French</option>
              <option value="de">German</option>
            </select>
            <ReactMapGL
                mapStyle={'https://tiles.locationiq.com/v3/streets/vector.json?key=pk.f44a7b07b5dc68e7a34ec03f2125e45e'}
                initialViewState={{
                    longitude: 48.4,
                    latitude: 10.8,
                    zoom: 3
                }}
                style={{ width: '100vw', height: '100vh' }}
                ref={mapContainerRef}
            />
        </div>
    );
};

/*
const Map = () => {
    const mapContainerRef = useRef(null);

    useEffect(() => {
        const map = new maplibregl.Map({
            container: mapContainerRef.current,
            style: 'https://tiles.locationiq.com/v3/streets/vector.json?key=pk.f44a7b07b5dc68e7a34ec03f2125e45e', // Map style URL
            center: [48.22, 10.73], // Starting position [lng, lat]
            zoom: 3, // Starting zoom
        });

        map.on('load', () => {
            map.getStyle().layers.forEach((layer) => {
                if (layer.id.search(/label/) >= 0) {
                    map.setLayoutProperty(layer.id, 'text-field', [
                        'coalesce',
                        ['get', 'name_de'],
                        ['get', 'name'],
                    ]);
                }
            });
        });

        // Clean up on unmount
        return () => map.remove();
    }, []);

    return (
        <div
            ref={mapContainerRef}
            style={{ width: '100%', height: '100vh' }} // Full screen map
        />
    );
};
*/

export default Map;
